import { render } from "./AllVideos.vue?vue&type=template&id=39a86cab"
import script from "./AllVideos.vue?vue&type=script&lang=js"
export * from "./AllVideos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__